/**
 * 지금 열어 둔 캠페인의 «클라이언트 금액 숨김» 상태(2026-11-05 Junha Park).
 *
 * 금액 칸을 그리는 컴포넌트가 수십 군데라(인플루언서·진행중·결과·콘텐츠 재사용 표와 요약 카드) 각자에게 값을 내려주지 않고,
 * 권한 훅(usePermission)이 이 값을 읽어 클라이언트의 canViewClientPrice 를 꺼 준다. 그러면 이미 그 권한으로 숨기던 칸이 한꺼번에 숨는다.
 * 캠페인 상세 화면이 캠페인을 불러올 때 채우고, 화면을 떠나면 비운다.
 */
let state = { campaignId: null, hidden: false };
const listeners = new Set();

export const getClientPriceHiddenState = () => state;

export const setClientPriceHiddenFor = (campaignId, hidden) => {
  const next = { campaignId: campaignId || null, hidden: hidden === true };
  if (next.campaignId === state.campaignId && next.hidden === state.hidden) return;
  state = next;
  listeners.forEach((fn) => fn());
};

export const clearClientPriceHidden = () => setClientPriceHiddenFor(null, false);

export const subscribeClientPriceHidden = (fn) => {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
};
